  let _gridElements = [];
  let Grid = {
    getGrid: function (e) {
      return _gridElements[e.val()]
    },
    setGrid: function (e, a = {values: {}}) {
      if (!e.val()) {
        let b = 0;
        while (_gridElements[b] !== undefined) {
          b++;
        }
        e.val(b);
      }

      if (a.values.selectionMethod === undefined) {
        a.values.selectionMethod = "checkbox";
      }

      if (a.values.pager === undefined) {
        a.values.pager = {};
      }

      if (a.values.pager.startIndex === undefined) {
        a.values.pager.startIndex = 1;
      }

      if (a.values.pager.limit === undefined) {
        a.values.pager.limit = 6;
      }

      if (a.values.pager.sizes === undefined) {
        a.values.pager.sizes = [
          a.values.pager.limit, a.values.pager.limit * 2, a.values.pager.limit * 5, a.values.pager.limit * 20];
      }

      a.values.pager.limit = a.values.pager.sizes[a.values.pager.startIndex];
      a.values.defaultCheckBoxColumnWidth = 40;
      a.values.locale = 'pt-br';

      if (this.getGrid(e)) {
        this.getGrid(e).destroy();
      }
      _gridElements[e.val()] = e.grid(a.values);
    },
    getSelectedFromGrid: function (e) {
      if (this.getGrid(e) === undefined || !this.getGrid(e).getSelected()) {
        return null;
      }
      return this.getGrid(e).getAll()[this.getGrid(e).getSelected() - 1];
    }
  }
